<template>
    <div class="dqlist-views">
        <!-- 引入公共端头部组件 -->
        <headNav></headNav>
        <!-- 搜索短期项目 -->
        <search @mysearch="isSearchFn($event)"></search>
        <div class="searchTextIsEmpty-box" v-show="searchTextIsEmpty">
            <!-- 封面海报 -->
            <transition-group tag="div" class="post-img-wrap" name="hotItemActive" mode="out-in">
                <a href="javascript: void(0)" v-for="item in postImg" :key="item.id">
                    <img :src="item.img" :alt="item.title">
                </a>
            </transition-group>
            
            <!-- 系列导航 -->
            <div class="dq-list-wrap">
                <ul>
                    <router-link to="/dqlist/ChineseFood" tag="li" activeClass="dq-listNav-link">中餐<br />系列</router-link> 
                    <router-link to="/dqlist/DessertFood" tag="li" activeClass="dq-listNav-link">西点<br />系列</router-link> 
                    <router-link to="/dqlist/WesternStyleFood" tag="li" activeClass="dq-listNav-link">西餐<br />系列</router-link>
                    <router-link to="/dqlist/DrinkFood" tag="li" activeClass="dq-listNav-link">饮品<br />系列</router-link>
                </ul>
            </div>
            <transition tag="div" name="hotItemActive" mode="out-in">
                <router-view />
            </transition>
        </div>
        <!-- 公共底footer栏 -->
        <publicFoot></publicFoot>
    </div>
</template>

<script>
import headNav from "@/components/HeadNav"
import search from "@/components/Search" // 搜索区域
import publicFoot from "@/components/PublicFoot" // foot 底部

import baseMixin from "@/mixins/baseMixin";

export default {
    name: 'dqList',
    mixins: [baseMixin], // 注入mixin
    data() {
        return {
            postImg: [], // 二级海报封面
            searchTextIsEmpty: true // 默认没有搜索，其他内容显示
        }
    },
    components: {
        headNav,
        search,
        publicFoot
    },
    methods: {
        /* 本地获取数据 */
        getLocalDataByFetch(callBack){
            fetch('/assets/json/dqList.json')
                .then((res) => {
                    return res.json();
                })
                .then((data) => {
                    callBack && callBack(data);
                })
        },
        isSearchFn(e){ // 是否点击了搜索
            // console.log(e);
            if(e == ''){
                this.searchTextIsEmpty = true;
            }else{
                this.searchTextIsEmpty = false; // 隐藏其他内容来显示搜索的结果
            }
        },
        changePostImgByIndexFn(){ // 通过路径更换海报
            var This = this;
            this.getLocalDataByFetch(function(data){
                var list = This.filterDataType(data.dqlistData,'postImg');
                if( This.$route.params.type ){
                   var typeIndex = This.$route.params.type.split('-')[1];
                }
                setTimeout(()=>{
                    This.postImg = list.filter((item)=>{
                        return item.type.indexOf(typeIndex) != -1
                    });
                },600)
            })
        }
    },
    mounted() {
        this.changePostImgByIndexFn();
    },
    watch:{
        $route(){
            this.changePostImgByIndexFn();
        }
    }
}
</script>

<style lang="less" scoped>
@rem: 40rem;
@w100: 640/@rem;

.justify {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.auto(@w) {
    width: @w/@rem;
    margin: 0 auto;
}

// 圆角
.radius(@radius) {
    border-radius: @radius/@rem @radius/@rem @radius/@rem @radius/@rem;
}

.linefont(@lineHeight, @fontSize, @color) {
    line-height: @lineHeight/@rem;
    font-size: @fontSize/@rem;
    color: @color;
}

.backgroundUrl(@img) {
    background: url(@img) no-repeat center / contain;
}

.aimg(@h) {
    a {
        display: block;

        img {
            width: 100%;
            height: @h/@rem;
        }
    }
}

// vue闪烁问题
[v-cloak] {
    display: none;
}
// 封面海报
.post-img-wrap{
    height: 320/@rem;
    .aimg(320);
}
// 系列导航
.dq-list-wrap{
    ul{
        &:extend(.justify);
        text-align: center;
        background: #eeeeee;
        padding-bottom: 20/@rem;
        li{
            flex: 1;
            .linefont(33, 30, #000);
            .radius(4);
            box-shadow: 2px 2px 2px 1px #d3d3d3;
            background: #fff;
            border: 1px solid #fff;
            padding-top: 20/@rem;
            padding-bottom: 20/@rem;
        }
        .dq-listNav-link{
            color: #eb6100;
            border: 1px solid #eb6100;
            box-shadow: 2px 2px 2px 1px #eb6100;
        }
    }
}
// 路由详情页颜色
.class-list-wrap{
    background: #fff;
    padding-bottom: (35/@rem);
}

// 【进入】动画效果
.hotItemActive-enter-active{
    animation: translate-in .5s;
}
// 【离开】动画效果
.hotItemActive-leave-active{
    animation: translate-in .5s reverse;
}
@keyframes translate-in{
    0%{
        opacity: 0;
        transform: translateX(50%);
    }
    100%{
        opacity: 1;
        transform: translateX(0);
    }
}
</style>